/**
 * Catégorisation unifiée des projets (Académique / Production / Freelance / Alternance-Stage).
 *
 * Source de vérité partagée entre la section publique des projets et le
 * dashboard admin, afin qu'un même projet soit toujours classé dans la même
 * catégorie des deux côtés.
 *
 * Règles (dans l'ordre de priorité) :
 *  1. badge contient "production"                  → production
 *  2. badge contient "freelance"                   → freelance
 *  3. badge contient "alternance"/"stage"/"apprentissage" → alternance
 *  4. is_academic OU badge académique              → academique
 *     (académique / academic / examen / openclassrooms / o'clock / cursus)
 *  5. par défaut (projet professionnel)            → production
 */
export type ProjectCategory = 'academique' | 'production' | 'freelance' | 'alternance';

export interface CategorizableProject {
  is_academic?: boolean;
  badge?: string | null;
}

export function getProjectCategory(project: CategorizableProject): ProjectCategory {
  const badge = (project.badge || '').toLowerCase();

  if (badge.includes('production')) return 'production';
  if (badge.includes('freelance')) return 'freelance';

  if (
    badge.includes('alternance') ||
    badge.includes('stage') ||
    badge.includes('apprentissage')
  ) {
    return 'alternance';
  }

  if (
    project.is_academic ||
    badge.includes('académique') ||
    badge.includes('academique') ||
    badge.includes('academic') ||
    badge.includes('examen') ||
    badge.includes('openclassrooms') ||
    badge.includes("o'clock") ||
    badge.includes('oclock') ||
    badge.includes('cursus')
  ) {
    return 'academique';
  }

  // Par défaut, un projet professionnel non académique est considéré comme "production".
  return 'production';
}

export const CATEGORY_LABELS: Record<ProjectCategory, string> = {
  academique: 'Académique',
  production: 'Production',
  freelance: 'Freelance',
  alternance: 'Alternance/Stage',
};

export default getProjectCategory;
